<ui-header>
  <ui-fast-search class="header-app__fast-search"
                  (onChanged)="onChanged($event)"
                  *ngIf="isOpen">
  </ui-fast-search>
  <ui-header-menu></ui-header-menu>
  <div class="header-app__right">
    <lucide-icon
      name="search"
      class="header-app__icon-search"
      [size]="18"
      (click)="onOpenSearch()"
    ></lucide-icon>
    <button
      *ngIf="onWikiPage"
      (click)="onOpenFilters()"
      class="button button_not-button header-app__icon-filter">
      <lucide-icon name="funnel" class="icon-dark-gray header-app__filter-icon" [size]="18"></lucide-icon>
    </button>
    <!--<ui-notification class="notification_active"></ui-notification>-->
    <ui-user-menu></ui-user-menu>
  </div>
</ui-header>
